import { Discount, ProductQuantity } from "@/types";
import { ref } from "vue";

export const isOpen = ref(false);
export const state = ref<{
  discounts: Discount[];
  productQuantities: ProductQuantity[];
  deliveryPrice?: number;
  saleId?: number;
}>(null!);

let resolve: (v: Discount[]) => void;
let reject: () => void;

export const open = (
  productQuantities: ProductQuantity[],
  discounts: Discount[] = [],
  deliveryPrice?: number,
  saleId?: number
): Promise<Discount[]> => {
  state.value = {
    productQuantities,
    discounts,
    deliveryPrice,
    saleId,
  };
  isOpen.value = true;

  return new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
};

export const close = (value: Discount[]): void => {
  isOpen.value = false;
  resolve?.(value);
};

export const cancel = (): void => {
  isOpen.value = false;
  reject?.();
};
